// extracted by mini-css-extract-plugin
export default {"titleModal":"ModalGo_titleModal__WovTg","flexCenter":"ModalGo_flexCenter__9yElZ","containerButton":"ModalGo_containerButton__TB8+2"};